<template>
  <div ref="lineChart" style="width: 600px; height: 400px;"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(newValue) {
        if (newValue.xAxisData.length > 0 && newValue.seriesData.length > 0) {
          this.$nextTick(() => {
            this.initChart();
          });
        }
      },
      immediate: true // 立即触发一次handler
    }
  },
  methods: {
    initChart() {
      if (this.chart) {
        this.chart.dispose(); // 避免重复初始化
      }

      if (!this.$refs.lineChart) return;

      this.chart = echarts.init(this.$refs.lineChart);

      // 处理 series 数据，确保每个 series 都有 type 字段和颜色
      const formattedSeriesData = this.chartData.seriesData.map((series, index) => ({
        ...series, // 保留原有的所有属性
        type: 'line', // 添加 type 属性
        lineStyle: {
          color: this.getColor(index) // 根据索引获取颜色
        }
      }));

      const option = {
        tooltip: { trigger: 'axis' },
        // legend: {
        //   data: formattedSeriesData.map(s => s.name)
        // },
        xAxis: {
          type: 'category',
          data: this.chartData.xAxisData
        },
        yAxis: { type: 'value' },
        series: formattedSeriesData // 使用处理后的数据
      };

      this.chart.setOption(option);
    },
   getColor(index) {
      // 定义一组颜色
      const colors =  ['#259fff', '#f36067', '#ffc00e', '#c793f2', '#7d63ee', '#45f8ff', '#5fd3fd'];;
      return colors[index % colors.length]; // 如果系列超过颜色数组长度，则循环使用颜色
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>

<style scoped>
/* 可以在这里添加样式 */
</style>